import { createFileRoute, redirect } from "@tanstack/react-router";

// Preserve historic speaking links without maintaining a second offer catalog.
export const Route = createFileRoute("/book-speaking")({
  beforeLoad: ({ location }) => {
    // An absent server-visible fragment must stay absent so browsers retain inbound hashes.
    throw redirect({ to: "/book-carlai", hash: location.hash || undefined, replace: true, statusCode: 301 });
  },
});
